var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slider",class:_vm.size},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"subline inc"}),_c('div',{staticClass:"subline dec"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }